module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'form-group': true,
      'has-error': this.m_error !== null
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.field.label))]), _vm._v(" "), (!_vm.field.allowsMultipleChoice) ? _c('select', {
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.disabledAttribute
    },
    domProps: {
      "value": _vm.getAnswerValueForSelect()
    },
    on: {
      "change": _vm.onChange
    }
  }, _vm._l((_vm.field.options), function(o) {
    return _c('option', [_vm._v(_vm._s(o))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.field.allowsMultipleChoice) ? _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.field.options), function(o) {
    return _c('div', {
      staticClass: "col-xs-12"
    }, [_c('label', {
      staticClass: "checkbox-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.m_fieldAnswer.value),
        expression: "m_fieldAnswer.value"
      }],
      attrs: {
        "type": "checkbox",
        "disabled": _vm.disabledAttribute
      },
      domProps: {
        "value": o,
        "checked": Array.isArray(_vm.m_fieldAnswer.value) ? _vm._i(_vm.m_fieldAnswer.value, o) > -1 : (_vm.m_fieldAnswer.value)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.m_fieldAnswer.value,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = o,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.m_fieldAnswer, "value", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.m_fieldAnswer, "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.m_fieldAnswer, "value", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(o)
      }
    })])])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67f8e4e3","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/quizzes/questions/fields/MultipleChoiceField.vue
// module id = 737
// module chunks = 1